import { cancellableRequest } from 'src/services/api.js';

export const CuratorsResource = {
  search({ companyId, query }) {
    const params = { q: query };
    const url = `/api/frontend/companies/${companyId}/vacancies/load_members`

    return cancellableRequest({
      method: 'get',
      url,
      params,
    })
  },
  getByVacancy({ companyId, vacancyId }) {
    const url = `/api/frontend/companies/${companyId}/vacancies/${vacancyId}/curators`

    return cancellableRequest({
      method: 'get',
      url,
    })
  },
  /**
   * @param {number|string} vacancyId
   * @param {string} companyId
   * @param {number[]} users
   * @return {import('axios').AxiosPromise}
   */
  setForVacancy({ vacancyId, companyId, users }) {
    const url = `/api/frontend/companies/${companyId}/vacancies/${vacancyId}/update_curators`

    return cancellableRequest({
      method: 'put',
      url,
      params: { user_ids: users }
    })
  },

  getByCompanyAlias({ companyAlias, offset }) {
    const params = { offset };
    const url = `/api/frontend/companies/${companyAlias}/public_members`;

    return cancellableRequest({
      method: 'get',
      url,
      params,
    });
  }
}
